import styled from 'styled-components'

export const DocumentCreateEditWrapper = styled.div`
  & > div:first-child {
    & > div:nth-child(3) {
      & > div:first-child {
        padding: 40px;
        margin: 0 0 30px 0;
      }
    }

    & > div:nth-child(5) {
      float: right;
    }
  }
`
